import { render } from "./TwilioClient.vue?vue&type=template&id=242fcfb2"
import script from "./TwilioClient.vue?vue&type=script&lang=js"
export * from "./TwilioClient.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/share/application/sanar-provider-webapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__